import Loadable from "@loadable/component";

const ForgotPassword = Loadable(
  () =>
    import(/* webpackChunkName: "forgot_password_page" */ "./forgotPassword")
);

export default ForgotPassword;
